import React, { useEffect, useRef } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Modal from '@material-ui/core/Modal';
import Backdrop from '@material-ui/core/Backdrop';
import Fade from '@material-ui/core/Fade';
import LinearProgress from '@material-ui/core/LinearProgress';
import { Button, TextField, Link, FormHelperText } from '@material-ui/core';
import { useCookies } from 'react-cookie';


const useStyles = makeStyles(theme => ({
    modal: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'     
    },
    paper: {
        backgroundColor: theme.palette.background.paper,
        outline: 0,        
        boxShadow: theme.shadows[5],
        padding: theme.spacing(2, 4, 3),
        textAlign: 'center',
        width: '500px',
        position: 'relative'
    },
    title: {
        fontWeight: 300,
        fontSize: '24px',
        textAlign: 'center',
        marginTop: theme.spacing(9),
        marginBottom: theme.spacing(.5)        
    },
    subtitle: {
        marginBottom: '36px',
        marginTop: '5px',
        color: '#757575',
        fontWeight: 100
    },
    form : {
        width: '340px',
        margin: '0 auto',
        '& *' : {
            width: '100%'
        },
        '& $fieldWrapper' : {
            margin: 0
        }
    },
    fieldWrapper: {},
    link: {
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
        '& a' : { cursor: 'pointer'}
    },
    btnSuccess : {
        height: '48px'
    },
    iconClose: {
        position: 'absolute',
        top: theme.spacing(3),
        right: theme.spacing(3)
    },
    linearProgress: {
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%'
    },
    backdrop: {
        backdropFilter: 'blur(5px)'
    }
}));

export default function TransitionsModal(props) {
    const classes = useStyles();
    const [open, setOpen] = React.useState(false);   
    const [email, setEmail] = React.useState('');
    const [pass, setPass] = React.useState('');
    const [sending, setSending] = React.useState(false); 
    const [error, setError] = React.useState(false); 
    const [ck, setCk] = useCookies([]);

    let emailInputRef = useRef(null);
    let passInputRef = useRef(null);

    
    const handleChange = event => { 
        if (error)
            setError(false);       

        if (event.target.name === 'email')
            setEmail(event.target.value)
        if (event.target.name === 'pass')
            setPass(event.target.value)
    }    

    const handleClose = () => {
        setOpen(false);
    };

    const sendForm = () => {        

        if (email !== '' && pass!== '' && !sending) {
            setSending(true);
            fetch('https://www.agroads.com.ar/miembros/login_valida.asp', {
                method: 'POST',
                credentials: 'same-origin',
                body: `login-email=${email}&login-pass=${pass}&get_data=y`,            
                headers: new Headers({
                    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
                })
            })
            .then(res => res.json())
            .then(res => {                
                if (res.respuesta) {
                    setOpen(false);
                    let dl = window.dataLayer;
                    let dlObj = {
                        'ruta': '/login/exito',
                        'titulo': 'AgroadsPrecios-Miembros-Acceso-Exito',
                        'userId': res.user_id,
                        'categoriaPagina': 'LoginExitoso',
                        'usuarioTipo': res.tag,
                        'usuarioUbicacion': res.ubicacion,
                        'event': 'pvvLoginExito'
                    }
                    dl.push(dlObj);
                }
                else {
                    setError(true)
                }
            })
            .catch(error => {
                setError(true)
            })
            .finally(()=> setSending(false))
        }
    }

    useEffect(() => {
        if (ck.usuario && ck.usuario !== '') {
            setEmail(ck.usuario)                        
        }
    }, []);

    useEffect(() => {    
        if (email === '' && emailInputRef.current) {
            emailInputRef.current.focus();
        } else {
            if (pass === '' && passInputRef.current) {
                passInputRef.current.focus();
            }
        }
    }, [emailInputRef.current, passInputRef.current]);

    useEffect(() => {        
        setOpen(props.isOpen);               
    },[props.isOpen]);
    

    return (                        
            <Modal
                aria-labelledby="transition-modal-title"
                aria-describedby="transition-modal-description"
                disableBackdropClick
                disableEscapeKeyDown
                className={classes.modal}
                open={open}
                onClose={handleClose}
                closeAfterTransition
                BackdropComponent={Backdrop}
                BackdropProps={{
                    timeout: 500,
                    classes : {
                        root: classes.backdrop                        
                    }
                }}
            >
                <Fade in={open}>
                    <div className={classes.paper}>                        
                        { sending ? <LinearProgress className={classes.linearProgress}></LinearProgress> : null }
                        <h2 className={classes.title}>Ingresar a Agroads</h2>
                        <h4 className={classes.subtitle}>Compará precios de 120.000 equipos</h4>
                        <form className={classes.form}>
                            <div className={classes.fieldWrapper}>
                                <TextField inputRef={emailInputRef} variant="outlined" type="email" name="email" placeholder="Email" value={email} onChange={handleChange}/>
                            </div>
                            <div className={classes.fieldWrapper}>
                                <TextField inputRef={passInputRef}variant="outlined" type="password" name="pass" placeholder="Contraseña" value={pass} onChange={handleChange}/>
                            </div>
                            {error ? <FormHelperText error>Los datos ingresados son incorrectos.</FormHelperText> : null }
                            <div className={classes.ErrorWrapper}></div> 
                            <div className={classes.link}>
                            <Link href="https://www.agroads.com.ar/miembros/recordar_clave.asp" target="_blank">Recordar contraseña</Link>
                            </div>
                            <Button disabled={sending || email==='' || pass===''} color="primary" variant="contained" className={classes.btnSuccess} onClick={sendForm}>Ingresar</Button>
                            <div className={classes.link}>
                                <Link href="https://www.agroads.com.ar/miembros/registrate.asp" target="_blank">¿No estás registrado? Registrate ahora!</Link>
                            </div>
                        </form>                        
                    </div>
                </Fade>
            </Modal>        
    );
}

